jQuery(document).ready(function ($) {
    var currentIndex = 0;
    var slides = $('.carousel-item');
    var totalSlides = slides.length;

    function updateSlides() {
        slides.removeClass('active next prev').css('left', '').css('right', '');
        
        var nextIndex = (currentIndex + 1) % totalSlides;
        var prevIndex = (currentIndex - 1 + totalSlides) % totalSlides;
        
        slides.eq(currentIndex).addClass('active').css('transform', '');
        slides.eq(nextIndex).addClass('next').css({
            'left': '0%',
            'transform': 'translate(-100%, 0%) scale(1)'
        }).off('click').on('click', function() {
            moveSlide('next');
        });
        slides.eq(prevIndex).addClass('prev').css({
            'right': '0%',
            'transform': 'translate(100%, 0%) scale(1)'
        }).off('click').on('click', function() {
            moveSlide('prev');
        });

        // Ensure the active slide does not trigger movement
        $('.active').off('click');


        // Hide all descriptions
        $('.carousel-description').css('display', 'none').css('opacity', '0');

        // Fade in the active description
        $('.active .carousel-description').css('display', 'block').delay(50).queue(function (next) {
            $(this).css('opacity', '1');
            next();
        });
    }

    function moveSlide(direction) {
        currentIndex = direction === 'next' ? (currentIndex + 1) % totalSlides : (currentIndex - 1 + totalSlides) % totalSlides;
        updateSlides();
    }

    // Carousel controls
    $('.carousel-control.next').click(function () {
        moveSlide('next');
    });

    $('.carousel-control.prev').click(function () {
        moveSlide('prev');
    });

    // Initialize the carousel
    updateSlides();
});
